import React from 'react';
import { AppIdea } from '@/hooks/app-library';
import { TextContentContext } from '@/components/text-content-lightbox';
import { AppIdeaContentHeader, AppIdeaResearchSection } from './content';
import { Skeleton } from '@/components/ui/skeleton';

export const AppIdeaContentRenderer: React.FC<{
  idea: AppIdea;
  context: TextContentContext<AppIdea>;
}> = ({ idea, context }) => {

  if (context.isLoading) {
    return (
      <div className="space-y-6">
        <div className="border-b pb-4 mb-6">
            <Skeleton className="h-8 w-3/4 mb-2" />
            <Skeleton className="h-4 w-full" />
        </div>
        <div className="space-y-8">
            <Skeleton className="h-24 w-full" />
            <Skeleton className="h-24 w-full" />
        </div>
      </div>
    );
  }

  return (
    <div className="relative space-y-6 min-w-0 w-full max-w-full">
      <AppIdeaContentHeader idea={idea} context={context} />
      <AppIdeaResearchSection idea={idea} />
    </div>
  );
};
